export default __webpack_public_path__ + "static/media/yellow_pawn.245f5e79.png";